import dayjs from "dayjs";
export const EMPTY_FIELD_PLACEHOLDER = "—";

export const TABLE_EMPTY_PLACEHOLDER = "-";

export const extractRecipientName = (recipientPartyName) =>
  recipientPartyName?.split(" - ")[1] ||
  recipientPartyName ||
  EMPTY_FIELD_PLACEHOLDER;

export const getMerchantName = (merchantObj) => {
  const name = merchantObj?.merchantName || merchantObj?.name;
  return name == null || name === "" ? TABLE_EMPTY_PLACEHOLDER : name;
};

export const getPaymentMethod = (
  serviceCode,
  payoutAccountType,
  gatewayReference,
) => {
  switch (serviceCode) {
    case "PC2B":
      return "MobileMoney Collection";
    case "PB2C": {
      switch (payoutAccountType) {
        case "MOBILE_MONEY":
          return "MM Withdrawal";
        case "BANK":
          return "Bank Withdrawal";
        case "WALLET":
          return "Wallet Transfer";
        default:
          return "Withdrawal";
      }
    }
    case "LipaBidhaa": {
      const ref = gatewayReference || "";
      if (ref.startsWith("LB2MP")) return "M-Pesa Paybill"; // legacy
      if (ref.startsWith("LB2MT")) return "M-Pesa Till Number"; // legacy
      if (ref.startsWith("LB2PK")) return "Paykit Transfer";
      if (ref.startsWith("LB2M")) return "M-Pesa Payment";
      return "Lipa Bidhaa";
    }
    case "LipaBidhaaC2B":
      return "Lipa Bidhaa Collection";
    case "PB2B":
      return "B2B Transfer";
    default:
      return "—";
  }
};

export const parseDateRange = (dateRange) => {
  try {
    const start = dateRange?.startDate
      ? dayjs(dateRange.startDate).toDate()
      : null;
    const end = dateRange?.endDate ? dayjs(dateRange.endDate).toDate() : null;
    return [start, end];
  } catch (err) {
    console.error("Error parsing date range:", err);
    return [null, null];
  }
};
